export default __webpack_public_path__ + "c844a9e189bd233c160372ba29fe62b5.png";